import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    salaryRequest: string,
    entranceDate: Date | null,
    periodFrom: Date | null,
    periodTo: Date | null,
    weeklyWorkingHours: string,
    remainingStudyTime: string,
    becomingAwareThrough: string,
    becomingAwareThroughOther: string,
    // Zusatzdokumente
    letterFile: File | undefined,
    workCertificatesFiles: File[] | null,  //
    currentGradeSheetFiles: File[] | null,  //
    academicCertificatesFiles: File[] | null,  //
    workInternReferencesFiles: File[] | null,  //
    halfYearCertificatesFiles: File[] | null,  //
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    salaryRequest: string = "";
    entranceDate: Date | null = null;
    periodFrom: Date | null = null;
    periodTo: Date | null = null;
    weeklyWorkingHours: string = "";
    remainingStudyTime: string = "";
    becomingAwareThrough: string = "";
    becomingAwareThroughOther: string = "";
    letterFile: File | undefined = undefined;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    workCertificatesFiles: File[] | null = null;
    currentGradeSheetFiles: File[] | null = null;
    academicCertificatesFiles: File[] | null = null;
    workInternReferencesFiles: File[] | null = null;
    halfYearCertificatesFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "salaryRequest", value: this.salaryRequest },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "periodFrom", value: this.periodFrom?.toString() ?? "" },
            { name: "periodTo", value: this.periodTo?.toString() ?? "" },
            { name: "weeklyWorkingHours", value: this.weeklyWorkingHours },
            { name: "remainingStudyTime", value: this.remainingStudyTime },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughOther", value: this.becomingAwareThroughOther },
        );

        return application;
    }
}
